import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import CasinoIcon from "@mui/icons-material/Casino";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Ball from "./Ball";
import { elevatedCard, elevatedRow } from "./cardStyle";

const NoActiveLottery = ({ isAuthenticated, lastResult }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        background:
          "linear-gradient(135deg, #0d2b16 0%, #123c1f 40%, #191919 100%)",
        border: "1px solid #03B34955",
        borderRadius: "18px",
        p: { xs: 3.5, md: 5.5 },
        mt: isAuthenticated ? 0 : "60px",
        position: "relative",
        overflow: "hidden",
        textAlign: "center",
        ...elevatedCard,
      }}
    >
      <Box sx={{ position: "absolute", right: -30, top: -30, opacity: 0.06 }}>
        <CasinoIcon sx={{ fontSize: 260, color: "#fff" }} />
      </Box>
      <Box sx={{ position: "absolute", left: -30, bottom: -30, opacity: 0.06 }}>
        <CasinoIcon sx={{ fontSize: 200, color: "#fff" }} />
      </Box>
      <Box
        sx={{
          position: "absolute",
          left: "50%",
          top: "10%",
          transform: "translateX(-50%)",
          width: 280,
          height: 280,
          borderRadius: "50%",
          background: "radial-gradient(circle, #03B34933 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 72,
          height: 72,
          borderRadius: "50%",
          background: "linear-gradient(135deg, #03B349, #016A2B)",
          boxShadow: "0 10px 30px rgba(3,179,73,0.35)",
          mb: 3,
        }}
      >
        <AutoAwesomeIcon sx={{ fontSize: 34, color: "#fff" }} />
      </Box>

      <Typography
        sx={{
          color: "#fff",
          fontWeight: 900,
          fontSize: { xs: "26px", md: "38px" },
          lineHeight: 1.2,
        }}
      >
        The Next Big Draw{" "}
        <Box component="span" sx={{ color: theme.palette.custom.green01 }}>
          Is Being Prepped
        </Box>
      </Typography>
      <Typography
        sx={{
          color: "#ffffffbb",
          mt: 1.5,
          fontSize: { xs: "14px", md: "16px" },
          maxWidth: 460,
          mx: "auto",
        }}
      >
        No lottery is live right now — check back soon for fresh numbers,
        a fresh jackpot, and a fresh shot at winning.
      </Typography>

      {lastResult && (
        <Box
          sx={{
            mt: 2.5,
            display: "inline-flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            gap: 1.2,
            background: "#00000044",
            border: `1px solid ${theme.palette.custom.yellow}44`,
            borderRadius: "14px",
            px: 2.2,
            py: 1.4,
            ...elevatedRow,
          }}
        >
          <EmojiEventsIcon sx={{ fontSize: 20, color: theme.palette.custom.yellow }} />
          <Typography sx={{ color: "#ffffffdd", fontSize: "13px" }}>
            Last draw paid out{" "}
            <Box component="span" sx={{ color: theme.palette.custom.yellow, fontWeight: 800, fontSize: "15px" }}>
              {/* prizeDisplay is formatted server-side in the player's own
                  currency; there is no SC wallet in this product. */}
              {lastResult?.prizeDisplay}
            </Box>{" "}
            ({lastResult?.name})
          </Typography>
          <Box sx={{ display: "flex", gap: 0.8 }}>
            {lastResult?.drawnNumbers?.map((n) => (
              <Ball key={n} num={n} max={lastResult?.maxNumber || 30} size={30} />
            ))}
          </Box>
        </Box>
      )}
    </Card>
  );
};

export default NoActiveLottery;
